import "client-only";
import useSWR from "swr";
import { fetcher } from "src/utils/fetcher";

function useBulkReturnProcessingList(params) {
  return useSWR(
    {
      path: "/api/v1/return-logs",
      method: "GET",
      params,
    },
    fetcher,
    {
      revalidateOnFocus: false,
    },
  );
}

export default useBulkReturnProcessingList;
